
import { Component, Vue, Watch } from 'vue-property-decorator'
import { BModal, BButton, BForm, BFormGroup, BFormSelect, BFormCheckbox, BFormInput, BInputGroupAppend, BInputGroup } from 'bootstrap-vue'
import { namespace } from 'vuex-class'
import api from '@/api'
import { email } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import { VueRecaptcha } from 'vue-recaptcha'
import { ProductApiModel } from '@/interfaces/ProductApiModel'

extend('emailList', value => {
  if (email.validate(value.split(',').map((s: string) => s.trim()))) { return true }
  return 'Please provide valid emails.'
})

const currentModel = namespace('currentModel')
const globalValues = namespace('globalValues')

@Component({
  components: {
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormInput,
    BInputGroupAppend,
    BInputGroup
  }
})
export default class SaveConfigurationModal extends Vue {
  public name: string | undefined = ''
  public visible = false;
  public showLoadingSpinner = false;
  public nameExists = false;

  @currentModel.State
  public configurationKey!: string

  @globalValues.Action
  public setNotification!: (message?: string) => void

  get baseLink() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
  }

  public mounted() {
    if (window.configurationName) {
      this.name = window.configurationName
    }
  }

  public getValidationState({ dirty, validated, valid }: { dirty: boolean; validated: boolean; valid: boolean }) {
    return dirty || validated ? valid : null
  }

  public async onSubmit(overwrite = false) {
    this.showLoadingSpinner = true
    try {
      await this.save(overwrite)
    } catch {
      this.showLoadingSpinner = false
      this.setNotification('Error while saving configuration')
    }

    return true
  }

  @Watch('name', { deep: true })
  onFormChanged(val: string, oldVal: string) {
    if (val !== oldVal) {
      this.nameExists = false
    }
  }

  public async checkIfExists() {
    this.showLoadingSpinner = true
    const result = await api
      .post('/configuration/exists/', { name: this.name })

    this.nameExists = result.data.exists
    this.showLoadingSpinner = false
  }

  public async save(overwrite = false) {
    await this.checkIfExists()

    if (this.nameExists && !overwrite) {
      return
    }

    const result = await api
      .post('/configuration/' + this.configurationKey + '/save/', { name: this.name })

    if (result.status === 200) {
      this.visible = false
      this.setNotification('Configuration saved!')
      this.showLoadingSpinner = false
      if (window.configurationName) { delete window.configurationName }
      this.name = undefined
    } else {
      console.log(result)
      this.setNotification('Error while saving configuration: ' + result.statusText)
      this.showLoadingSpinner = false
    }
  }
}
